import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { showMessage } from './navbarSlice';

import axios from 'axios';

const getHeaders = () => ({
  headers: {
    'x-api-key': localStorage.getItem('token'),
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const callAPI = createAsyncThunk(
  'api/callAPI',
  async ({ method, url, data }, { rejectWithValue,dispatch  }) => {
    try {
      const response = await axios({
        method,
        url,
        data,
        ...getHeaders(),
      });
   
      return { method, data: response.data, id: data?.id };
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      if (err.response?.status === 401) {
         if (err.response?.status === 401) {
        localStorage.removeItem('token');
        dispatch(showMessage('Unauthorized! Please login again.'));
        window.location.href = '/admin/login'; 
      }
      }

      return rejectWithValue(message);
    }

  }
);

export const callFileDownload = createAsyncThunk(
  'api/callFileDownload',
  async ({ url, filename }, { rejectWithValue, dispatch }) => {
    try {
      

      const response = await axios({
        method: "GET",
        url,
        responseType: "blob",
        ...getHeaders()
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "download.csv";
      link.click();

      return true;
    } catch (err) {
      const message = err.response?.data?.message || err.message;

      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        dispatch(showMessage("Unauthorized! Please login again."));
        window.location.href = "/admin/login";
      }

      return rejectWithValue(message);
    }
  }
);


export const checkAdminUser = createAsyncThunk(
  'api/checkAdminUser',
  async ({ method, url, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios({
        method,
        url,
        ...getHeaders(),
      });
      if (response.data?.success === false && response.data?.isAdmin === false) {
        dispatch(showMessage(response.data.message || "Access Denied"));
        return rejectWithValue("ACCESS_DENIED");
      }

      return {
        method,
        data: response.data,
        id: data?.id
      };

    } catch (err) {
      const message = err.response?.data?.message || err.message;
      if (err.response?.status === 401) {
        localStorage.removeItem("token");

        dispatch(showMessage("Unauthorized! Please login again."));
        window.location.href = "/admin/login";

        return rejectWithValue("UNAUTHORIZED");
      }

      return rejectWithValue(message);
    }
  }
);


const apiSlice = createSlice({
  name: 'api',
  initialState: {
    items: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearItems: (state) => {
      state.items = [];
      state.current = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(callAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(callAPI.fulfilled, (state, action) => {
        state.loading = false;
        const { method, data } = action.payload;

        if (method === 'get') {
          if (Array.isArray(data)) {
            state.items = data; // fetch all
          } else {
            state.current = data; // fetch by id
            const idx = state.items.findIndex((i) => i.id === data.id);
            if (idx !== -1) state.items[idx] = data;
            else state.items.push(data);
          }
        } else if (method === 'post') {
          state.items.push(data); // create
        } else if (method === 'patch') {
          const idx = state.items.findIndex((i) => i.id === data.id);
          if (idx !== -1) state.items[idx] = data;
        } else if (method === 'delete') {
          state.items = state.items.filter((i) => i.id !== action.payload.id);
        }
      })
      .addCase(callAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearItems } = apiSlice.actions;
export default apiSlice.reducer;
